import { render } from "./Dash.vue?vue&type=template&id=677f6213&scoped=true"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"

import "./custom-dashboard.scss?vue&type=style&index=0&id=677f6213&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f6213"]])

export default __exports__